import styled from 'styled-components';

export default styled.div`
	position: sticky;
	width: 100%;
	height: 2px;
	background-image: ${(props) => props.theme.images.lineGradient};
	flex-grow: 0;
	flex-shrink: 0;
`;
